
export const FLOW_METRICS_SET = "FLOW_METRICS_SET";
export const FLOW_SENDER_PROFILES_SET = "FLOW_SENDER_PROFILES_SET";
export const FLOW_SENDER_PROFILES_METRICS_SET = "FLOW_SENDER_PROFILES_METRICS_SET";
